import { useEffect, useRef } from 'react';
import { DocsVerificationStepEnum } from '@models/enums';
import { VERIFICATION_POLL_INTERVAL_MS } from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/docs-verification-steps/finish/hooks/constants';
import { useLazyGetVerificationByIdQuery } from '@modules/docs-verification-widget/api';
import { useAppDispatch, useAppSelector } from '@store';
import { docsVerificationSlice } from '@store/slices/docs-verification';

export const useCustomPartnerFetchStatus = () => {
    const dispatch = useAppDispatch();
    const sdkOptions = useAppSelector((state) => state.docsVerification.sdkOptions);
    const concordium = sdkOptions?.customPartner?.concordium;
    const timer = useRef<ReturnType<typeof setInterval>>();
    const [getVerificationById, { data: verificationData }] = useLazyGetVerificationByIdQuery();

    useEffect(() => {
        if (!concordium || !sdkOptions?.id || !sdkOptions?.apiUrl) {
            return undefined;
        }

        timer.current = setInterval(() => {
            getVerificationById({
                id: sdkOptions.id,
                url: sdkOptions.apiUrl,
            });
        }, VERIFICATION_POLL_INTERVAL_MS);

        return () => {
            if (timer.current) {
                clearInterval(timer.current);
            }
        };
    }, [concordium, getVerificationById, sdkOptions?.apiUrl, sdkOptions?.id]);

    useEffect(() => {
        if (!verificationData?.status || verificationData.status === 'active') {
            return;
        }

        if (timer.current) {
            clearInterval(timer.current);
        }

        if (verificationData.status === 'completed') {
            dispatch(docsVerificationSlice.actions.setCurrentStep(DocsVerificationStepEnum.FINISH));
        }
    }, [dispatch, verificationData?.status]);
};
